export default "__VITE_ASSET__Bw$Vw7kp__"